import { MandatoryExtra } from "@/helpers/types/types.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setMandatoryExtrasHelper = (state: EngineStoreData, itemId: string, extra: MandatoryExtra[]) => {
  const newItems = state.cartAccommodationItems?.map((item) => {
    if (item.id === itemId) {
      return { ...item, mandatoryExtras: extra };
    }
    return item;
  });
  return { cartAccommodationItems: newItems };
};
